import React, { FunctionComponent, useEffect, useLayoutEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';
import styles from "./Common.module.scss"
import { data } from './local';
import { Button, Collapse, createStyles, makeStyles, Menu, MenuItem, Select, Theme, Typography } from '@material-ui/core';
import SearchBox from './SearchBox';
import { Box } from '@mui/material';
import DashboardVideo from './DashboardVideo';
import Awards from './Awards';
import Faq from './Faq';
import NominationCards from './NominationCards';
import { eventEmitter, getNominatorMail, getToken, getUserGraphId, getUserInfo, setIsEnabled } from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Column } from 'devextreme-react/data-grid';
import moment from 'moment';
import { appInsights } from "../AppInsights";
import { getClosureData, getNominatorInfo } from './services';
import { getConfig } from '../services/ConfigService';
import { useMsal } from '@azure/msal-react';


const HomePage: FunctionComponent<any> = () => {
    const { accounts } = useMsal();
    const account = accounts[0];

useEffect(()=>{
    return getConfig().then((config: any) => {
       let viaSiteUrl = config.SiteUrl;
    {appInsights.trackPageView({name:"VIAHomePageLoaded",uri:viaSiteUrl,properties:{CorrelationId:getcorrelationId(),AccountIdentifier: getUserGraphId()}})}
    });
},[])
    let history: any = useHistory()
    const [token, setToken] = useState<any>(null);
    useEffect(() => {        
        getToken().then((token: any) => {
            setToken(token);
        });
    }, [])
    const [state, setState] = React.useState<boolean>(true);
    const [closureMessage, setClosureMessage] = React.useState<string>(" ");
    const [userName , setUserName]=React.useState<string>(" ");

    const getcorrelationId = () => {
        return sessionStorage.getItem("correlationId");
      }

    useEffect(() => {
       
        
        getClosureData().then((response: any) => {
            if (response != null) {
                setState(response.toggleState);
                setIsEnabled(response.toggleState);
                if (!response.toggleState) {
                    setClosureMessage(response.closureMessage);
                }
            }
            else{
                setIsEnabled(true);
            }
        });
    }, [])

      useLayoutEffect(() => {
        if (account) {
            const accountIdentifier = account.localAccountId || account.homeAccountId?.split('.')[0] || '';
            getNominatorInfo(accountIdentifier).then((response: any) => {
                if (response != null) {
                    setUserName(response.givenName+' '+response.surname);
                }
            });
        }
     }, [account])
    //  const languageSelected:any = useSelector((state:any) => state.lang);
    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;
    const { VIANominations } = languageData[languageSelected];
    const { NominationPeriodClosure } = languageData[languageSelected];
   

    const [isNominationsExpanded, setIsNominationsExpanded] = useState<boolean>(true);

    const handleNominationsClick = () => {
        setIsNominationsExpanded(!isNominationsExpanded);
  }
  const [isViaExpanded, setIsViaExpanded] = useState<boolean>(false);

    const handleViaClick = () => {
        setIsViaExpanded(!isViaExpanded);
  }
  const [isAwardeesExpanded, setIsAwardeesExpanded] = useState<boolean>(false);

    const handleAwardeesClick = () => {
        setIsAwardeesExpanded(!isAwardeesExpanded);
  }




    return (

        <React.Fragment>
            <Box sx={{ flexGrow: 1, bgcolor: '#FFFFFF', display: 'flex'}}>
             
            <div className={styles.homePage}>
                <div style={{padding:'40px'}}>
            <h2 className={styles.headerBold}>VIA Nominations</h2>
            <h2 className={styles.header}>{VIANominations.welcome}{userName}</h2>
            <div className={styles.messageBox}>
                        <div>{VIANominations.message} {VIANominations.thoughtStartersPrompt} <Link to="/thoughtStarters">{VIANominations.thoughtStartersLink}</Link></div>
                    </div>
                    <div>
                        <h2 className={styles.header}>{VIANominations.findAndNominate}</h2>
                        <hr/>
                        {token && <SearchBox title={VIANominations.selectLabel} token={token} />}
                    </div>
                    {/* {state ? ('') : (<div className={styles.space}> <h3>{closureMessage}</h3> </div>)} */}
                    {/* {state ? (<div>
                        <h2 className={styles.header}>{VIANominations.findAndNominate}</h2>
                        <hr/>
                        {token && <SearchBox title={VIANominations.selectLabel} token={token} />}
                    </div>) : (<div className={styles.space}> <h3>{closureMessage}</h3> </div>)}*/}
                    </div> 
            <br/>
            <br/>
            <br/>
            <Button variant="outlined" className={styles.collapseBttn} onClick={handleNominationsClick}>
            {VIANominations.nominationsHeader}
            <span className={styles.floatRight}>{!isNominationsExpanded? <AddIcon/> : <RemoveIcon/> }</span>
            </Button>
            <Collapse in={isNominationsExpanded} timeout="auto" unmountOnExit>
            {token && <NominationCards token={token} />}
            </Collapse>
            <Button variant="outlined" className={styles.collapseBttn} onClick={handleViaClick}>
            {VIANominations.valuesInActionHeader}
            <span className={styles.floatRight}>{!isViaExpanded? <AddIcon/> : <RemoveIcon/> }</span>
            </Button>
            <Collapse in={isViaExpanded} timeout="auto" unmountOnExit>
            <DashboardVideo />
            </Collapse>
            <Button variant="outlined" className={styles.collapseBttn} onClick={handleAwardeesClick}>
            {VIANominations.systemAwardeesHeader}
            <span className={styles.floatRight}>{!isAwardeesExpanded? <AddIcon/> : <RemoveIcon/> }</span>
            </Button>
            <Collapse in={isAwardeesExpanded} timeout="auto" unmountOnExit>
            <Awards />
            </Collapse>
            
            <Faq />
            </div>
            </Box>
            
        
        </React.Fragment>
    );
    
         }

export default HomePage;